import { BehaviorSubject, Observable } from 'rxjs';
import { GlobalService } from './global.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StorageService } from '@app/services/storage.service';
import { Usuario } from '@app/models';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  data: Date;
  ip: string;
  private currentUserSubject: BehaviorSubject<Usuario>;
  public currentUser: Observable<Usuario>;

  private usuario: Usuario;

  constructor(
    private http: HttpClient,
    private serviceGlobal: GlobalService,
    private serviceStorge: StorageService
  ) {
    this.currentUserSubject = new BehaviorSubject<Usuario>(
      this.serviceStorge.getAccessUsuario()
    );
    this.currentUser = this.currentUserSubject.asObservable();
    this.data = new Date();
  }

  public get currentUserValue(): Usuario {
    return this.currentUserSubject.getValue();
  }

  ehAdm(senha): boolean {
    let pass: string;
    if (environment.titulo === 'Portal do Colaborador') {
      pass = environment.secretAD;
    } else if (environment.titulo === 'Portal do Docente') {
      pass = environment.secretDocente;
    } else {
      pass = environment.secretAluno;
    }
    if (senha === pass) {
      return true;
    } else {
      return false;
    }
  }

  getDadosAleatorios(cpf) {
    let resultado: any;
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${environment.urlApiLogin}/dadosAleatorios/listarDadosAleatorios/${cpf}`
        )
        .subscribe(
          (result) => {
            this.serviceGlobal.exibirMensagem(result);
            resultado = result;
            resolve(resultado);
          },
          (error) => {
            this.serviceGlobal.exibirMensagem(error);
            resolve(error);
          }
        );
    });
  }

  getDadosAluno(cpf) {
    let resultado: any;
    return new Promise((resolve, reject) => {
      this.http
        .get(`${environment.urlApiLogin}/dadosAleatorios/buscaPorCpf/${cpf}`)
        .subscribe(
          (result) => {
            this.serviceGlobal.exibirMensagem(result);
            resultado = result;
            resolve(resultado);
          },
          (error) => {
            this.serviceGlobal.exibirMensagem(error);
            resolve(error);
          }
        );
    });
  }

  getIP() {
    this.serviceGlobal.getIPAddress().subscribe((res: any) => {
      this.ip = res.ip;
    });
  }

  login(credencial) {
    const login = credencial.login;
    const senha = credencial.senha;
    const tipo = credencial.tipo;
    const httpHeaders = new HttpHeaders()
      // origem: UniFTC One Portal (uniftc-one) ou UniFTC One App (uniftc-one-app)
      .set('origem', 'uniftc-one')
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${environment.urlApiLogin}/login`,
          { login, senha, tipo },
          { headers: httpHeaders, observe: 'response' }
        )
        .subscribe(
          (response: any) => {
            this.serviceGlobal.exibirMensagem(response.body);
            const token = response.headers
              .get('Authorization')
              .replace('Bearer ', '');
            const ehAdm: boolean = this.ehAdm(senha);
            const usuario = {
              codigo: response.body.id || response.body.codigo,
              login: response.body.cpf || response.body.usuario,
              nome: response.body.nome,
              ativo: response.body.ativo,
              setor: response.body.setor,
              perfil: response.body.perfil,
            };
            if (environment.tipo !== 'docente') {
              this.setUsuario(usuario, ehAdm, token, null, true, this.data);
            } else {
              let google = null;
              let exibirHome = false;
              // Se não for Produção, não precisa do Authenticator
              if (environment.ambiente !== 'Produção') {
                google = true;
                exibirHome = true;
              }
              this.setUsuario(
                usuario,
                ehAdm,
                token,
                google,
                exibirHome,
                this.data
              );
            }
            resolve(token);
          },
          (error) => {
            this.serviceStorge.setError(error);
            resolve(error);
          }
        );
    });
  }

  logout() {
    this.serviceStorge.logout();
    this.currentUserSubject.next(null);
    location.reload();
  }

  postLogin(usuario, senha, token, ip) {
    let tipoUsuario: string;
    if (environment.tipo === 'aluno') {
      if (senha === environment.secretAluno) {
        tipoUsuario = 'S';
      } else {
        tipoUsuario = 'A';
      }
    } else if (environment.tipo === 'docente') {
      if (senha === environment.secretDocente) {
        tipoUsuario = 'U';
      } else {
        tipoUsuario = 'D';
      }
    } else {
      if (senha === environment.secretAD) {
        tipoUsuario = 'P';
      } else {
        tipoUsuario = 'F';
      }
    }
    const body = {
      usuario,
      ip,
      tipoUsuario,
      token,
    };
    return new Promise((resolve, reject) => {
      this.http
        .post(`${environment.urlApiLogin}/api/acessoLog/cadastrar`, body)
        .subscribe(
          (result) => {
            this.serviceGlobal.exibirMensagem(result);
            // resolve(result);
          },
          (error) => {
            this.serviceGlobal.exibirMensagem(error);
            resolve(error);
          }
        );
    });
  }

  setSenha(cpf, senha) {
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${environment.urlApiLogin}/dadosAleatorios/atualizaSenha/${cpf}/${senha}`,
          null
        )
        .subscribe(
          (result) => {
            this.serviceGlobal.exibirMensagem(result);
            resolve(result);
          },
          (error) => {
            this.serviceGlobal.error(error);
          }
        );
    });
  }

  setUsuario(usuario, ehAdm, token, google, exibirHome, data) {
    if (environment.titulo === 'Portal do Colaborador') {
      this.usuario = {
        codigo: usuario.codigo,
        login: usuario.login,
        nome: usuario.nome,
        administrador: ehAdm,
        ativo: usuario.ativo,
        setor: usuario.setor,
        perfil: usuario.perfil,
        data,
        google,
        exibirHome,
        token,
      };
    } else if (environment.titulo === 'Portal do Docente') {
      this.usuario = {
        codigo: usuario.codigo,
        login: usuario.login,
        nome: usuario.nome,
        administrador: ehAdm,
        ativo: null,
        setor: 'Docente',
        perfil: null,
        data,
        google,
        exibirHome,
        token,
      };
    } else {
      this.usuario = {
        codigo: usuario.codigo,
        login: usuario.login,
        nome: usuario.nome,
        administrador: ehAdm,
        ativo: null,
        setor: 'Aluno',
        perfil: null,
        data,
        google,
        exibirHome,
        token,
      };
    }
    this.serviceStorge.setAccess(this.usuario);
    this.serviceGlobal.exibirMensagem(this.usuario);
    this.serviceStorge.cleanError();
  }
}
